import 'dayjs/locale/zh-cn'

export default {
	
}
